export const SET_DATA = (state, { id, data, isPush }) => {
  if (isPush) {
    state[id].push(data);
    return;
  }
  state[id] = data;
};
 export const setList =  (state, keyList) => {
    state[keyList.key] = keyList.list
  };
 export const setLengthList =  (state, keyLength) => {
    state[keyLength.key] = keyLength.lengths
  };
 export const clear =  (state) => {
    state.lengthList = 15
    state.listMyTransaction = []
    state.listAllTransaction = []
  };



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/accounting/mutations.js